import React, { Component } from 'react';
import ProductCounter from '../product-counter';
import ProductAttr from '../product-attr';
import { withDataPhone } from '../hoc';
import { connect } from 'react-redux';
import { addProduct, addLoading, addError } from '../../actions';
import Spinner from '../spinner';
import Error from '../error';
import './phone-single.css';

const PhoneSingle = ({ img, descr }) => {
  return (
    <div className="single-page">
      <div className="row">
        <div className="col-md-6">
          <div className="product_ceil">{img}</div>
        </div>
        <div className="col-md-6">{descr}</div>
      </div>
    </div>
  );
};

class PhoneSingleContainer extends Component {
  state = {
    error_message: '',
    count: 1,
    attr: '',
    product: {},
  };
  componentWillMount() {
    this.props.addLoading(true);
    let { id, phoneservice, addError } = this.props;
    phoneservice
      .getPhone(id)
      .then((data) => {
        this.setState({ product: data });
        this.props.addLoading(false);
      })
      .catch((err) => {
        addError(err);
      });
  }
  addClick = () => {
    let { count, attr, product } = this.state;
    let message = '';

    if (count >= 1 && isFinite(count) && attr !== '') {
      this.setState({ error_message: '' });
      this.props.history.push('/re-store/cart');
      let obj = Object.assign(product, { count });
      this.props.addProduct(obj);
    } else {
      if (count < 1 || !isFinite(count)) {
        message = 'Неверное количество товара';
      } else if (attr === '') {
        message = 'Выберете атрибут';
      }

      this.setState({ error_message: message });
    }
  };
  clickAttr = (attr) => {
    this.setState({ attr });
  };
  changeCount = (num) => {
    this.setState({ count: parseInt(num) });
  };

  render() {
    let { name, price, urlImage, description, attr = [] } = this.state.product;
    let { error_message } = this.state;
    let { loading, error } = this.props;
    if (error) {
      return <Error />;
    }
    const text = (
      <div className="product_description">
        <h2 className="product_name">{name}</h2>
        <span className="product_price">${price}</span>

        <p className="product_about">{description}</p>

        <ProductAttr data={attr} clickAttr={this.clickAttr} />

        <ProductCounter changeCount={this.changeCount} />
        <div className="product_add_cart">
          <button
            onClick={this.addClick}
            type="button"
            className="btn btn-primary btn-single-add"
          >
            <i
              className="fa fa-shopping-cart product-cart-icon"
              aria-hidden="true"
            ></i>{' '}
            <span>Add to Cart</span>
          </button>
        </div>
        <p className="error-message">{error_message}</p>
      </div>
    );

    let img = loading ? (
      <Spinner />
    ) : (
      <img src={urlImage} alt="Товары ReStore" />
    );
    let descr = loading ? <Spinner /> : text;

    return <PhoneSingle img={img} descr={descr} />;
  }
}

const mapStateToProps = ({ single, loading, error }) => {
  return {
    single,
    loading,
    error,
  };
};
const mapDispatchToProps = {
  addProduct,
  addLoading,
  addError,
};

export default withDataPhone()(
  connect(mapStateToProps, mapDispatchToProps)(PhoneSingleContainer),
);
